import styled from 'styled-components';
import { Collapse, Drawer, Modal, Tag } from 'antd';

export const AssetBoxWrapper = styled.div`
  padding: 20px;
  background-color: #e6faff;
`;

export const LoadingTipWrapper = styled.div`
  text-align: center;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-content {
    background-color: #f9f9f9;
    overflow: auto; /* Ensure no overflow */
  }
  .ant-drawer-header {
    background-color: #ffffff;
    color: black;
    font-size: 18px;
    font-weight: bold;
  }
  .ant-drawer-body {
    padding: 20px;
  }
`;

export const StyledCollapse = styled(Collapse)`
  background-color: #ffffff;
  .ant-collapse-header {
    font-weight: bold;
    color: black;
  }
`;

export const StyledTag = styled(Tag)`
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
`;

export const CountryText = styled.p`
  overflow: hidden;
  color: #222a30;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px; /* 150% */
  letter-spacing: -0.1px;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: 0 auto 10px;
  text-align: center;

  .icon {
    font-size: 30px;
    margin-right: 10px;
  }

  .text {
    font-size: 18px;
    color: purple;
    font-weight: bold;
  }
`;

export const CountrySectionWrapper = styled.div`
  margin-bottom: 16px;
`;

export const CountryStatusWrapper = styled.div`
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;
`;

export const AllowedPublishersText = styled.p`
  margin: 0;
`;

export const DeclinesWrapper = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 8px;
    width: 26px;
    height: 26px;
  }

  p {
    margin: 0;
  }
`;

export const PreviewModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const PreviewModalTitleText = styled.span`
  color: #222a30;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: InspireTWDC;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;

export const PreviewModalLinkImage = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin-left: 10px;
`;

export const StyledPreviewModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
`;

export const StyledVideo = styled.video`
  width: 100%; /* Video width */
`;
